export default "__VITE_ASSET__DuSwf2Vg__"